import { FacetOption } from '@/types/FacetOption';
import FacetTypes from '@/types/search/enums/facetTypes';

export type SearchFacet = {
    categories: {
        facets: SearchFacetItem[] | null;
    };
    count: number;
    id: string;
    name: string;
    options: FacetOption[] | undefined;
    range?: {
        max: number;
        min: number;
    };
    selected: boolean;
};

export type SearchFacetItem = {
    categories: SearchFacetItem[] | null;
    count: number;
    id: string;
    name: string;
    parents: null;
    selected: boolean;
};

export type FacetChipOption = {
    id?: string;
    label: string;
    value: FacetTypes;
};

export enum CurrentOpenMenu {
    AllFilters = 'all-filters',
    Category = 'category',
    Location = 'location',
    Rating = 'rating',
    Shipping = 'shipping',
}

export const MAX_FILTER_OPTIONS_COUNT = 11;
